module.exports = __webpack_public_path__ + "static/img/sam-cover-img-14.b4408af3.jpg";